import lodash from 'lodash'

export const maxInt = Number.MAX_SAFE_INTEGER ?? Math.pow(2, 53) - 1

/**
 * Modulo that works with negative numbers the same as positive numbers
 * https://stackoverflow.com/a/17323608/2648987
 */
export function symetricModulo(n: number, m: number) {
    return ((n % m) + m) % m
}

export function strictParseInt(str: string): number | null {
    return /^(-)?\d+$/.test(str) ? parseInt(str, 10) : null
}

/*
 * Parses floats from strings, returns null instead of NaN for failures
 * Does not support e numbers e.g. '2e4'
 * Does not allow strings that happen to start with numbers e.g. '23 hey there'
 * Allows numbers with multiple '.' in just for implementation ease e.g. '127.0.0.1' === 127
 * Allows negative numbers
 */
export function strictParseFloat(str: string) {
    return /^(-)?[\d.]+$/.test(str) ? parseFloat(str) : null
}

export function padToX(value: number, desiredLength: number) {
    return lodash.padStart(value.toString(), desiredLength, '0')
}

export function toFixedWithoutTrailingZeros(value: number, decimalPlaces: number): number {
    if (value == null) return null
    return +value.toFixed(decimalPlaces)
}

export function numberSort(a: number, b: number) {
    return a - b
}
